<main>
    <!-- <div *ngFor="let item of ['Item1', 'Item2', 'Item3']">
        <app-animation></app-animation>
        {{ item }}
    </div> -->
    <app-banner></app-banner>
    <app-about></app-about>
    <app-experience></app-experience>
    <app-projects></app-projects>
    <app-more-projects></app-more-projects>
    <app-education></app-education>
    <app-certifications></app-certifications>
    <app-contact></app-contact>
</main>

